import axios from "axios";
import { SERVER_URL } from "Constants";

/* ============================== Enable Or Disable Provider Products for Clients ================================================ */
export async function enableDisableBusinessEntityCreditReportSettings(id: string, enable: boolean) {
	// If enable is true, call enableBusinessEntityCreditReportSettings
	const url = `${SERVER_URL}/api/entity/BusinessEntityCreditReportSettingsEntity/${id}/enable-disable`;
	return await axios.post<string>(url, { isEnabled: enable });
}


export async function enableDisableProviderProductOrganisation(id: string, enable: boolean) {
	const url = `${SERVER_URL}/api/entity/ProviderProductOrganisationEntity/${id}/enable-disable`;
	return await axios.post<string>(url, { isEnabled: enable });
}

export async function enableDisableProviderProductsForEntities(id: string, enable: boolean, isOrganisationLevel: boolean) {
	if (isOrganisationLevel) {
		return enableDisableProviderProductOrganisation(id, enable);
	} else {
		return enableDisableBusinessEntityCreditReportSettings(id, enable);
	}
}

/* ============================== Super USER ACTIONS FOR CRUD Ops on PROVIDER PRODUCTS ================================================ */